/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Compare_Row_LicenseInputs */

const en_cad_compare_row_license = /** @type {(inputs: Cad_Compare_Row_LicenseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source code`)
};

/**
* | output |
* | --- |
* | "Source code" |
*
* @param {Cad_Compare_Row_LicenseInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const cad_compare_row_license = /** @type {((inputs?: Cad_Compare_Row_LicenseInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Compare_Row_LicenseInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cad_compare_row_license(inputs)
});
export { cad_compare_row_license as "cad.compare.row_license" }